import { createFileRoute } from '@tanstack/react-router'
import { LinkedAccounts, SettingsForm } from '@/features/users'
import { useMyProfile } from '@/features/users/services/users.convex'
import { ConnectedUserProfile } from '@/features/auth'
import { Skeleton } from '@/components/ui/skeleton'

export const Route = createFileRoute('/(dashboard)/settings/')({
  component: RouteComponent,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Settings' }],
  }),
})

function RouteComponent() {
  const { data: userData, isLoading } = useMyProfile()

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* User Profile Card Skeleton */}
          <div className="lg:col-span-1">
            <div className="p-6 bg-muted/30 rounded-lg space-y-6">
              <div className="text-center space-y-4">
                <Skeleton className="h-24 w-24 rounded-full mx-auto" />
                <div className="space-y-2">
                  <Skeleton className="h-6 w-32 mx-auto" />
                  <Skeleton className="h-4 w-48 mx-auto" />
                  <Skeleton className="h-3 w-40 mx-auto" />
                </div>
              </div>
              <Skeleton className="h-px" />
              <div className="space-y-4">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-12 w-full" />
              </div>
            </div>
          </div>

          {/* Settings Form Skeleton */}
          <div className="lg:col-span-2 space-y-6">
            <div className="p-6 bg-muted/30 rounded-lg space-y-6">
              <Skeleton className="h-8 w-40" />
              <div className="space-y-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>
              <Skeleton className="h-10 w-32" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!userData) return null

  const position = userData.position
  const manager = userData.manager

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start lg:items-stretch">
        {/* User Profile Card */}
        <div className="lg:col-span-1 flex flex-col">
          <ConnectedUserProfile
            manager={
              manager ? { id: manager.id, name: manager.name ?? '' } : null
            }
            position={
              position
                ? {
                    title: position.title,
                    role: position.role,
                    level: position.level,
                  }
                : null
            }
          />
        </div>

        {/* Settings Form */}
        <div className="lg:col-span-2 space-y-6">
          <SettingsForm user={userData} />
          <LinkedAccounts />
        </div>
      </div>
    </div>
  )
}
